import React from 'react';
import unavailable_blue from '../../../images/unavailable_blue.png';
import unavailable_gray from '../../../images/unavailable_gray.png';
import unavailable_pink from '../../../images/unavailable_pink.png';
import comingsoon from '../../../images/comingsoon.png';
import { Modal } from 'antd';

class UnavailablePopup extends React.Component {
  render() {
    const { color, t, isComingSoon } = this.props;
    const styles = {
      title: {
        marginBottom: 10,
        fontSize: 16,
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        textAlign: 'center',
        marginTop: 20
      },
      button: {
        margin: '0 auto',
        backgroundColor: color,
        color: 'white',
        border: 'none',
        borderRadius: '20px',
        width: 200,
        textAlign: 'center',
        marginTop: 20,
        cursor: 'pointer',
        padding: 10,
        marginBottom: 20
      }
    };

    let image;
    if (color == '#F190AC') {
      image = unavailable_pink;
    } else if (color == '#7c868d') {
      image = unavailable_gray;
    } else {
      image = unavailable_blue;
    }

    return (
      <Modal
        footer={false}
        visible={this.props.open}
        onCancel={this.props.close}
        width={450}>
        <img
          src={isComingSoon ? comingsoon : image}
          style={{
            maxWidth: 150,
            margin: '0 auto',
            display: 'block',
            marginTop: isComingSoon ? -24 : 40
          }}
        />
        {isComingSoon ? (
          <h3 style={styles.title}>Skill Tracker will be available soon!</h3>
        ) : (
          <h3 style={styles.title}>
            Ops! Looks like this service is not available in your list yet.
            Contact your school to let them know.
          </h3>
        )}
        <div onClick={() => this.props.close()} style={styles.button}>
          Done
        </div>
      </Modal>
    );
  }
}

export default UnavailablePopup;



// WEBPACK FOOTER //
// ./src/containers/StudentApp/components/unavailablePopup.js